import { createContext } from 'react';

const phoneContext = createContext({
    phone: {},
    setPhone: () => {}
});

export default phoneContext;
